<div class="generic-notification">
  <div class="generic-notification__type small text-muted">
    {{ 'AgenticCX::Notification:UnknownType' | abpLocalization }}: {{ notification.type }}
  </div>
  <div class="generic-notification__payload small text-break">{{ notification.payload }}</div>
</div>
